import { Avatar, Box, HStack, StackProps, Text } from '@chakra-ui/react';

interface Company {
  logo: string;
  name: string;
}

type Props = StackProps & {
  company: Company,
  description: string
}

export default function CompanyHeader({ company, description, ...props }: Props) {
  return (
    <HStack 
      spacing="13px"
      {...props}
    >
      <Avatar src={company.logo} />
      <Box>
        <Text as="strong">{company.name}</Text><br />
        <Text as="span">{description}</Text>
      </Box>
    </HStack>
  )
}
